import { render, staticRenderFns } from "./offres.vue?vue&type=template&id=4c1d7289&"
import script from "./offres.vue?vue&type=script&lang=js&"
export * from "./offres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports